import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaths } from 'app/_enums/api-paths';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const USER_ACCESS_KEY = 'auth-user-access';

const httpOptions = {
  headers: new HttpHeaders({'Accept': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  baseUrl = environment.baseUrl;
  currentUser?: Object;
  constructor(private http: HttpClient) { }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY); 
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public saveUserAccess(useraccess: any): void {
    window.sessionStorage.removeItem(USER_ACCESS_KEY);
    window.sessionStorage.setItem(USER_ACCESS_KEY, JSON.stringify(useraccess));
  }

  public getUserAccess(): any {
    const useraccess = window.sessionStorage.getItem(USER_ACCESS_KEY); 
    //console.log('useraccess', useraccess)
    if (useraccess) {
      return JSON.parse(useraccess);
    }
    return {};
  }

  public getUserInfo(): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.accounts}`;
    let curUser = this.getUser();
    return this.http.get(url + curUser['account_id'] + '/profile?uuid=' + curUser['uuid'], httpOptions)
  }

  public getUserAccessCall(): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.accounts}`;
    let curUser = this.getUser();
    return this.http.get(url + curUser['account_id'] + '/capabilities?uuid=' + curUser['uuid'], httpOptions)
  }

}